module.exports = __webpack_public_path__ + "static/media/bookshelf.d86f1113.png";